import {RootState} from '../../store';

// The slice stores the selected record keyed by id. Consumers of the selection
// hooks expect a boolean map (`selection[id] === true`), so the hook derives
// that from this — see useAccountsSelectionQuery.
export const selectionSelector = (state: RootState): Record<string, unknown> =>
    state.accounts.selection;
